var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsHorizontal = function SvgDotsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.994 15.724c-.926 0-1.634.708-1.634 1.642 0 .896.73 1.634 1.634 1.634.881 0 1.634-.738 1.634-1.634 0-.889-.753-1.642-1.634-1.642Zm0-5.354c-.926 0-1.634.708-1.634 1.626 0 .896.73 1.634 1.634 1.634.881 0 1.634-.738 1.634-1.634 0-.88-.753-1.626-1.634-1.626Zm0-5.37c-.926 0-1.634.708-1.634 1.634 0 .904.73 1.642 1.634 1.642.881 0 1.634-.738 1.634-1.642 0-.88-.753-1.634-1.634-1.634Z"
  })));
};
export default SvgDotsHorizontal;